export default [
  /*** 信息资讯 开始 ***/
  {
    path: '/article/list',
    component: () => import('../pages/content/article/index.vue'),
    meta: { title: '信息资讯管理' }
  },
  {
    path: '/article/edit/:articleId',
    component: () => import('../pages/content/article/edit.vue'),
    meta: { title: '信息资讯编辑' }
  },
 
  {
    path: '/article/create',
    component: () => import('../pages/content/article/create.vue'),
    meta: { title: '信息资讯创建' }
  },
  {
    path: '/article/category',
    component: () => import('../pages/content/article/category.vue'),
    meta: { title: '文章分类管理' }
  },
  /*** 信息资讯 结束 ***/

  /*** 参考书管理 开始 ***/
  {
    path: '/consult/category',
    component: () => import('../pages/content/consult/category.vue'),
    meta: { title: '参考书分类管理' }
  },
  {
    path: '/consult/list',
    component: () => import('../pages/content/consult/index.vue'),
    meta: { title: '参考书' }
  },
  {
    path: '/consult/:consultId',
    component: () => import('../pages/content/consult/detail.vue'),
    meta: { title: '参考书' }
  },
  /*** 参考书管理 结束 ***/


  /*** 题目管理 开始 ***/
  {
    path: '/examQuestions/list',
    component: () => import('../pages/content/examQuestions/index.vue'),
    meta: { title: '题目管理' }
  },
  {
    path: '/examQuestions/edit',
    component: () => import('../pages/content/examQuestions/edit.vue'),
    meta: { title: '题目修改' }
  },
  {
    path: '/examQuestions/create',
    component: () => import('../pages/content/examQuestions/create.vue'),
    meta: { title: '题目创建' }
  },

  /*** 题目管理 结束 ***/



  /*** 题库管理 开始 ***/
  {
    path: '/exam/list',
    component: () => import('../pages/content/exam/index.vue'),
    meta: { title: '在线题库' }
  },
  {
    path: '/exam/detail/:examId',
    component: () => import('../pages/content/exam/detail.vue'),
    meta: { title: '在线题库' }
  },
  {
    path: '/exam/detail/:examId/chapter/:chapterId',
    component: () => import('../pages/content/exam/paper.vue'),
    meta: { title: '题库试卷编辑' }
  },
  {
    path: '/exam/create',
    component: () => import('../pages/content/exam/create.vue'),
    meta: { title: '题库创建' }
  },
  {
    path: '/exam/edit/:examId',
    component: () => import('../pages/content/exam/edit.vue'),
    meta: { title: '题库编辑' }
  },
  {
    path: '/exam/bugreport',
    component: () => import('../pages/content/exam/report.vue'),
    meta: { title: '错题上报' }
  },
  {
    path: '/exam/bugreport/detail/:id',
    component: () => import('../pages/content/exam/reportdetail.vue'),
    meta: { title: '错题上报详情' }
  },
  /*** 题库管理 结束 ***/

  /*** 阅读管理 开始 ***/
  {
    path: '/read/list',
    component: () => import('../pages/content/read/index.vue'),
    meta: { title: '阅读资料' }
  },
  {
    path: '/read/detail/:readId',
    component: () => import('../pages/content/read/detail.vue'),
    meta: { title: '阅读资料' }
  },
  {
    path: '/read/detail/:readId/chapter/:chapterId',
    component: () => import('../pages/content/read/paper.vue'),
    meta: { title: '阅读资料编辑' }
  },
  {
    path: '/read/create',
    component: () => import('../pages/content/read/create.vue'),
    meta: { title: '阅读资料创建' }
  },
  {
    path: '/read/edit/:readId',
    component: () => import('../pages/content/read/edit.vue'),
    meta: { title: '阅读资料编辑' }
  },
  {
    path: '/read/category',
    component: () => import('../pages/content/read/category.vue'),
    meta: { title: '阅读资料分类管理' }
  },
  /*** 阅读管理 结束 ***/

  /*** 课程管理 开始 ***/
  {
    path: '/course/list',
    component: () => import('../pages/content/course/index.vue'),
    meta: { title: '课程管理' }
  },
  {
    path: '/course/detail/:courseId',
    component: () => import('../pages/content/course/detail.vue'),
    meta: { title: '课程详情' }
  },
  {
    path: '/course/detail/:courseId/paper/:paperId',
    component: () => import('../pages/content/course/paper.vue'),
    meta: { title: '随堂练习详情' }
  },
  {
    path: '/course/create',
    component: () => import('../pages/content/course/create.vue'),
    meta: { title: '课程创建' }
  },
  {
    path: '/course/edit/:courseId',
    component: () => import('../pages/content/course/edit.vue'),
    meta: { title: '课程编辑' }
  },
   {
    path: '/course/testPaper/:courseId/paper/:paperId',
    component: () => import('../pages/content/course/edittestPaper.vue'),
    meta: { title: '课程试卷编辑' }
  },
  {
    path: '/course/category',
    component: () => import('../pages/content/course/category.vue'),
    meta: { title: '课程分类管理' }
  },
  /*** 课程管理 结束 ***/

  /*** 实体资料管理 开始 ***/
  {
    path: '/material/list',
    component: () => import('../pages/content/material/index.vue'),
    meta: { title: '实体资料管理' }
  },
  {
    path: '/material/edit/:materialId',
    component: () => import('../pages/content/material/edit.vue'),
    meta: { title: '实体资料编辑' }
  },
  {
    path: '/material/create',
    component: () => import('../pages/content/material/create.vue'),
    meta: { title: '实体资料创建' }
  },
  {
    path: '/material/category',
    component: () => import('../pages/content/material/category.vue'),
    meta: { title: '实体资料分类管理' }
  },
  /*** 实体资料管理 结束 ***/

  /*** 资源管理 开始 ***/
  {
    path: '/resource/paper',
    component: () => import('../pages/resource/paper/index.vue'),
    meta: { title: '试卷管理' }
  },
  {
    path: '/resource/paper/:paperId',
    component: () => import('../pages/resource/paper/detail.vue'),
    meta: { title: '试卷编辑' }
  },
  {
    path: '/resource/trash',
    component: () => import('../pages/resource/trash/index.vue'),
    meta: { title: '内容回收站' }
  },
  /*** 资源管理 结束 ***/

  /*** 推荐管理 开始 ***/
  {
    path: '/recommend/list',
    component: () => import('../pages/content/recommend/list.vue'),
    meta: { title: '推荐列表' }
  },
  {
    path: '/recommend/position',
    component: () => import('../pages/content/recommend/position.vue'),
    meta: { title: '推荐位置' }
  },
  /*** 推荐管理 结束 ***/

  /*** 内容版块 开始 ***/
  {
    path: '/section/list',
    component: () => import('../pages/content/section/list.vue'),
    meta: { title: '常规版块' }
  },
  {
    path: '/section/list/:sectionId',
    component: () => import('../pages/content/section/detail.vue'),
    meta: { title: '版块内容' }
  },
  {
    path: '/section/college/list',
    component: () => import('../pages/content/section/college.vue'),
    meta: { title: '院校专业' }
  },
  /*** 内容版块 结束 ***/
]
